import { render, staticRenderFns } from "./chinesebridge.vue?vue&type=template&id=0f6247b2&scoped=true"
import script from "./chinesebridge.vue?vue&type=script&lang=js"
export * from "./chinesebridge.vue?vue&type=script&lang=js"
import style0 from "./chinesebridge.vue?vue&type=style&index=0&id=0f6247b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6247b2",
  null
  
)

export default component.exports